export const NAVIGATE = 'navigation/NAVIGATE';

export type NavigatePayload =
  | string
  | {
      pathname: string;
      search?: string;
      hash?: string;
    };

export type NavigateAction = {
  type: typeof NAVIGATE;
  payload: NavigatePayload;
  replace?: boolean;
};

export const navigate = (
  to: NavigatePayload,
  options?: { replace?: boolean }
): NavigateAction => ({
  type: NAVIGATE,
  payload: to,
  replace: options?.replace,
});

/** Saga-compatible alias for connected-react-router `push`. */
export const push = (to: NavigatePayload) => navigate(to);

/** Saga-compatible alias for connected-react-router `replace`. */
export const replace = (to: NavigatePayload) => navigate(to, { replace: true });
